import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'

import { cn } from '../../lib/utils'
import { MFDiscoverButtonLoader } from './mf-discover-button-loader'

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-semibold ring-offset-background transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-45',
  {
    variants: {
      variant: {
        default:
          'bg-primary-600 text-white shadow-[0_8px_24px_rgba(40,24,255,0.18)] hover:bg-primary-700',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline:
          'border-[1.5px] border-black-950 bg-white text-black-950 hover:bg-black-50 dark:border-[var(--fb-border-strong)] dark:bg-[var(--fb-surface)] dark:text-[var(--fb-text)] dark:hover:bg-[var(--fb-surface-raised)]',
        secondary: 'bg-secondary-300 text-black-950 hover:bg-secondary-400',
        ghost:
          'bg-transparent text-black-950 hover:bg-black-100 dark:text-[var(--fb-text)] dark:hover:bg-[var(--fb-surface-raised)]',
        link: 'text-primary-600 underline-offset-4 hover:underline dark:text-[var(--fb-accent-text)]',
        revoke: 'text-error-500',
        simple: '',
        fabitsWhite:
          'border border-black-200 bg-white rounded-lg text-black-950 dark:border-[var(--fb-border)] dark:bg-[var(--fb-surface)] dark:text-[var(--fb-text)]',
        back: 'border-b lg:border-none w-full flex justify-start items-center rounded-none',
      },
      size: {
        default: 'h-11 px-5 py-3',
        sm: 'h-9 px-4',
        lg: 'h-12 px-8',
        icon: 'h-10 w-10',
        simple: '',
        back: 'h-12 p-4 lg:p-0 m-0 ',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

const Button = React.forwardRef(
  (
    { className, variant, size, asChild = false, loading = false, children, disabled, ...props },
    ref,
  ) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        disabled={disabled || loading}
        {...props}
      >
        {loading ? <MFDiscoverButtonLoader className='h-5 w-14' /> : children}
      </Comp>
    )
  },
)
Button.displayName = 'Button'

const FabitsButton = React.forwardRef(
  (
    { className, variant, size, asChild = false, loading = false, children, disabled, ...props },
    ref,
  ) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        disabled={disabled || loading}
        {...props}
      >
        {loading ? <MFDiscoverButtonLoader className='h-5 w-14' /> : children}
      </Comp>
    )
  },
)
FabitsButton.displayName = 'FabitsButton'

export { Button, FabitsButton, buttonVariants }
